import { IGameState } from 'State/Game/IGameState';

export enum IAPDebugMode {
    DEFAULT = 'default',
    ALWAYS_FAIL = 'always_fail',
    ALWAYS_SUCCEED = 'always_succeed',
}

export function SetIAPDebugMode(state: IGameState, mode: IAPDebugMode): IGameState {
    switch (mode) {
        case IAPDebugMode.DEFAULT:
        case IAPDebugMode.ALWAYS_FAIL:
        case IAPDebugMode.ALWAYS_SUCCEED:
            return {
                ...state,
                perSessionData : {
                    ...state.perSessionData,
                    iapDebugMode: mode,
                }

            };
        default:
            console.log(
                `Error: Please specify valid IAP debug mode: ${[
                    IAPDebugMode.DEFAULT,
                    IAPDebugMode.ALWAYS_FAIL,
                    IAPDebugMode.ALWAYS_SUCCEED,
                ].join(', ')}`
            );
    }

    // Should not get here.
    return state;
}
